import React, { useLayoutEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputText } from '../../../formikBindings';
import {
  FormGroup,
  ButtonContainer,
  SubmitButton,
  ToggleButtonGroup,
} from '../../../form';
import { IVisitorTypeFormValues, IVisitorTypeFormProps } from './types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const icons: Array<IconProp> = [
  'user',
  'user-hard-hat',
  'taxi',
  'person-carry',
  'user-graduate',
];

const VisitorTypeForm: React.FC<IVisitorTypeFormProps> = ({ onDelete }) => {
  const { values, setFieldValue } = useFormikContext<IVisitorTypeFormValues>();

  const nameElement = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    nameElement.current?.focus();
  }, []);

  const renderToggleButton = (icon: IconProp) => (
    <ToggleButtonGroup.Button key={icon.toString()} id={icon.toString()}>
      <FontAwesomeIcon icon={icon} size="2x" />
    </ToggleButtonGroup.Button>
  );
  return (
    <>
      <FormGroup name="icon" label="Icon" required>
        <ToggleButtonGroup
          activeKey={values.icon.toString()}
          onChange={(value) => setFieldValue('icon', value, false)}
        >
          {icons.map(renderToggleButton)}
        </ToggleButtonGroup>
      </FormGroup>

      <FormGroup name="name" label="Name" required>
        <InputText ref={nameElement} name="name" maxLength={255} />
      </FormGroup>

      <ButtonContainer>
        {onDelete && (
          <Button variant="danger" onClick={onDelete}>
            Delete
          </Button>
        )}
        <SubmitButton>Save</SubmitButton>
      </ButtonContainer>
    </>
  );
};

export default VisitorTypeForm;
